import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListStudent = createAsyncThunk('student-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListArchiveStudent = createAsyncThunk(
  'student-archive-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/archive-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createStudent = createAsyncThunk('student-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editStudent = createAsyncThunk('student-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentDetails = createAsyncThunk(
  'student-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/details/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const changeStudentStatus = createAsyncThunk(
  'change-student-status',
  async ({id, type}: {type: string; id: string}, thunkAPI) => {
    try {
      await axios.get(`${api}student/change-student-status/${id}/${type}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetTermClassByStudent = createAsyncThunk(
  'get-term-class-by-student',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-term-class-by-student/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentClassMove = createAsyncThunk('move-student', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/move`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentBySemester = createAsyncThunk(
  'student-by-semester',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-student-by-semester`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintSemesterBookReport = createAsyncThunk(
  'print-semester-book',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/print-semester-book`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SemesterBookStudentExcel = createAsyncThunk(
  'semester-book-students',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/excel-students-semester-book`, data, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Semester Book Students.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const StudentCreditReport = createAsyncThunk(
  'student-credit-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/credit-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintCreditReport = createAsyncThunk(
  'student-credit-report-print',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/credit-report-print`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListStudentUpgrade = createAsyncThunk(
  'student-list-for-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/list-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentSemesterUpgrade = createAsyncThunk(
  'student-semester-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/semester-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ChangeStdPhoto = createAsyncThunk('change-photo', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/change-photo`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ChangeStdPassword = createAsyncThunk('change-password', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}student/change-password`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentCardPrint = createAsyncThunk('std-card-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/print-card/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentSemesters = createAsyncThunk(
  'student-semesters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-semesters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentSemesterScore = createAsyncThunk(
  'student-semester-score',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-semester-score`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuSemesters = createAsyncThunk(
  'student-semesters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-stu-semesters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuAttendance = createAsyncThunk(
  'student-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-stu-attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStdSemesters = createAsyncThunk('std-semesters', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/std-semseters/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemSubs = createAsyncThunk(
  'get-sem-subs',
  async ({semId, stdId}: {stdId: string; semId: string}, thunkAPI) => {
    try {
      const res = await axios.get(`${api}thesis/sem-subjects/${semId}/${stdId}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSubLecturers = createAsyncThunk('get-sub-lecs', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/sub-lecturers/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeThesis = createAsyncThunk('store-thesis', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}thesis/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const stdTheses = createAsyncThunk('theses', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/list/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editThesis = createAsyncThunk('thesis-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const approveThesis = createAsyncThunk('thesis-approve', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/approve/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteThesis = createAsyncThunk('thesis-destroy', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}thesis/destroy/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentGraduationBook = createAsyncThunk(
  'student-graduation-book',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/get-graduation-book`, data, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Graduation Book.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const GetStudentGraduationBookPrint = createAsyncThunk(
  'student-graduation-book-print',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/print-graduation-book`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStuTranscript = createAsyncThunk('thesis-destroy', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/get-transcript/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getUpgradeSemesters = createAsyncThunk(
  'get-upgrade-semesters-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student/get-upgrade-semesters-list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const isShownSemesterBook = createAsyncThunk(
  'is-shown-semester-book',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}student/update-is-shown-semester-book`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStudents = createAsyncThunk('print-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student/print-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentExcel = createAsyncThunk('student-excel', async (params: {}) => {
  const response = await axios.get(`${api}student/excel-students`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Student List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

type studentState = {
  errors: any
}

const initialState: studentState = {
  errors: '',
}

export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentSlice.actions
export default studentSlice.reducer
